import React from 'react';

export default function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Background escuro com blur */}
      <div 
        className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" 
        onClick={onClose}
      ></div>

      {/* 🚀 AJUSTE AQUI: Adicionado max-h e flex-col */}
      <div className="relative w-full max-w-2xl bg-white rounded-3xl shadow-2xl border border-slate-100 p-8 z-10 animate-in fade-in zoom-in duration-200 max-h-[90vh] flex flex-col">
        
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-red-500 text-2xl transition-colors z-20"
        >
          &times;
        </button>

        {/* 🚀 AJUSTE AQUI: overflow-y-auto permite o scroll apenas no conteúdo */}
        <div className="mt-2 overflow-y-auto pr-2 custom-scrollbar">
          {children}
        </div>
      </div>
    </div>
  );
}